import type { SupportIssueType } from './components/SupportIssueModalContent';

import { useTranslation } from 'react-i18next';

import { createSupportIssue } from '../../lib/flotiq-client/api-helpers';

import SuccessIssueCreatedModal from './components/SuccessIssueCreatedModal';
import SupportIssueModalContent from './components/SupportIssueModalContent';

import useSelectedSpace from '../../hooks/useSelectedSpace';
import useToken from '../../hooks/useToken';

import { defaultButtonsProps, useModals } from '../../contexts/ModalContext';

export const supportIssuesModalId = 'support-issue-form-modal';

export const useSupportIssues = (testId: string = '') => {
  const modal = useModals();
  const jwt = useToken();
  const { space } = useSelectedSpace();
  const { t } = useTranslation();

  const onSubmit = async (value: SupportIssueType) => {
    if (!jwt) {
      return false;
    }
    const ok = await createSupportIssue(jwt, space, value, t);
    if (ok) {
      await modal({
        content: <SuccessIssueCreatedModal testId={testId} />,
        size: 'lg',
        buttons: [
          {
            ...defaultButtonsProps.ok,
            label: t('Global.Ok'),
            result: true,
          },
        ],
      });
    }
    return ok;
  };

  const handleSupportIssues = async () => {
    return await modal({
      id: supportIssuesModalId,
      title: t('SupportIssueModal.Title'),
      content: <SupportIssueModalContent onSubmit={onSubmit} testId={testId} />,
      size: 'lg',
      dialogAdditionalClasses: 'text-slate-900',
      contentAdditionalClasses:
        'px-6 md:px-11 pb-20 text-slate-900 md:overflow-visible',
    });
  };

  return { handleSupportIssues };
};
